import React from 'react';

import { AddTestCasesProvider } from '@qality/common-components/src/lib/AddTestCasesProvider';
import { ProjectIssueTypesProvider } from '@qality/common-components/src/lib/ProjectIssueTypesProvider';
import { TestCyclesProvider } from '@qality/common-components/src/lib/TestCyclesProvider';
import { StorageOfUniqueServices } from '@qality/common-service';

import { AddTestCasesFormView } from './AddTestCasesForm.view';
import { AddTestCasesFormValues } from './types';

export const AddTestCasesForm: React.FC = () => {
  const initialValues: AddTestCasesFormValues = {
    issues: [],
  };

  React.useEffect(() => {
    StorageOfUniqueServices.get('AP').sizeToParent(true);
  });

  return (
    <AddTestCasesProvider>
      <TestCyclesProvider>
        <ProjectIssueTypesProvider>
          <AddTestCasesFormView initialValues={initialValues} />
        </ProjectIssueTypesProvider>
      </TestCyclesProvider>
    </AddTestCasesProvider>
  );
};
